import styled from 'styled-components'

const StyledNetworkItem = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`

export default StyledNetworkItem
